// Constants
const CONTENTFUL_IMAGES_HOSTNAME = 'images.ctfassets.net';
const HTTPS_PROTOCOL = 'https:';

// Types
export interface ContentfulUrlParameter {
  name: string;
  value: string;
}

/**
 * Adds multiple query parameters to Contentful image URLs
 * @param url - The URL to modify (can be absolute, protocol-relative, or already have query params)
 * @param parameters - Array of parameter objects with name and value properties
 * @returns The modified URL with the specified parameters added if it's a Contentful image URL
 */
export function addParametersToContentfulUrl(url: string, parameters: ContentfulUrlParameter[]): string {
  if (!url || !parameters || parameters.length === 0) return url;

  try {
    // Handle protocol-relative URLs by temporarily adding https:
    const isProtocolRelative = url.startsWith('//');
    const fullUrl = isProtocolRelative ? `${HTTPS_PROTOCOL}${url}` : url;

    // Parse the URL
    const urlObj = new URL(fullUrl);

    // Check if it's a Contentful images URL
    const isContentfulImages = urlObj.hostname === CONTENTFUL_IMAGES_HOSTNAME;

    if (!isContentfulImages) {
      return url; // Return original URL if not Contentful images
    }

    // Add all specified parameters
    parameters.forEach(({ name, value }) => {
      urlObj.searchParams.set(name, value);
    });

    // Return the modified URL, preserving the original protocol format
    const result = urlObj.toString();
    return isProtocolRelative ? result.replace(HTTPS_PROTOCOL, '') : result;

  } catch (error) {
    // If URL parsing fails, return original URL
    console.warn('Failed to parse URL:', url, error);
    return url;
  }
}
